import "@smile_identity/smart-camera-web";
import React, { useEffect } from "react";

const SmartCameraForMobile = () => {

    useEffect(() => {
        const handleImagesComputed = (e: Event) => {
          const customEvent = e as CustomEvent;
          if((window as any)?.ReactNativeWebView && (window as any).ReactNativeWebView.postMessage){
              (window as any)?.ReactNativeWebView.postMessage(JSON.stringify(customEvent.detail));
            }
        };
    
        const app = document.querySelector("smart-camera-web");
        if (app) {
          app.addEventListener(
            "imagesComputed",
            handleImagesComputed as EventListener
          );
        }
    
        // Cleanup the event listener on component unmount
        return () => {
          if (app) {
            app.removeEventListener(
              "imagesComputed",
              handleImagesComputed as EventListener
            );
          }
        };
      }, []);

    return(
      <div className="fixed inset-0 flex font-manrope justify-center items-start pt-12 pb-20 overflow-auto bg-white dark:bg-[#141414]  bg-opacity-10 backdrop-blur-sm">
        <div className="w-11/12 mds:w-9/12 md:6/12 lgss:w-1/2 xxl:w-[35%] xxxl:w-[25%]  transition-all ease-in duration-1000 border  dark:border-[#303030] border-[#E6E6E6] mx-auto px-3 lgss:px-6 dark:bg-[#1F1F1F]  rounded-xl bg-white pb-10">
          <div className="bg-white w-full fixed flex flex-col justify-start items-center pt-12  inset-0  lgss:top-16  pb-12 dark:bg-[#141414] backdrop-blur-sm">
            <div className="bg-white border w-11/12 overflow-auto mds:w-8/12 md:7/12 border-gray-400 rounded-xl pt-12 py-6 lgss:py-12  lgss:w-2/5 xxl:w-1/3  flex flex-col justify-center items-center">
              <smart-camera-web></smart-camera-web>
            </div>
          </div>
        </div>
      </div>
    )
}
export default SmartCameraForMobile
